import React, { Component } from 'react';

import { bool, string } from 'prop-types';

import { SuperscriptionItemAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { expression } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames } from '@philips-emr/tws-utils';

import { Tooltip } from '..';
import { TooltipTrigger } from '../tooltip/constants';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: SuperscriptionItemAPI })
class SuperscriptionItem extends Component {
  static propTypes = {
    className: string,
    color: string,
    label: expression,
    showLabel: bool,
    value: string,
  };

  render() {
    const { className, color, label, showLabel } = this.props;

    const ref = node => node && node.style.setProperty('background-color', color, 'important');

    const names = classNames({
      'c-superscription__item': true,
      [className]: Boolean(className),
    });

    return (
      <Tooltip value={label} trigger={showLabel ? TooltipTrigger.ELLIPSIS : TooltipTrigger.HOVER}>
        <div className={names}>
          <div className="c-superscription__circle" ref={ref} />
          {showLabel && (
            <span className="c-superscription__label u-truncate">{msg(label)}</span>
          )}
        </div>
      </Tooltip>
    );
  }
}

export default SuperscriptionItem;
